// extracted by mini-css-extract-plugin
export default {"pageTitle":"PageTitle_pageTitle__xAv+5","pageTitleStandfirst":"PageTitle_pageTitleStandfirst__qqume"};